import { render } from "./WizardPage.vue?vue&type=template&id=63fff0e3"
import script from "./WizardPage.vue?vue&type=script&lang=js"
export * from "./WizardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__